import { Dialog } from '@material-ui/core';
import cn from 'classnames';
import { t } from 'i18next';
import { FC, RefObject } from 'react';

import TrashIcon from './TrashIcon.svg?react';

import { systemBetGroupNameArray } from 'features/coupon/utility';
import Button from 'shared/components/form/button';
import './styles.scss';

interface Props {
	showGroupingDialog: boolean;
	setShowGroupingDialog: () => void;
	dialogRef: RefObject<HTMLDivElement>;
	outcomeId: string;
	isBanker?: boolean;
	removeBet: (outcomeId: string) => void;
	handleGroupChange: (outcomeId: string, groupIndex: number) => void;
	handleSelectedBet: (value: boolean, outcomeId: string) => void;
	groupArray: number[];
	numOfItemsInBetslip: number;
	getSystemBetGroupName: (outcomeId: string) => string | undefined;
}

const SystemBetGroupingPopup: FC<Props> = (props) => {
	const {
		showGroupingDialog,
		dialogRef,
		removeBet,
		handleGroupChange: changeGroup,
		handleSelectedBet,
		groupArray,
		numOfItemsInBetslip,
		outcomeId,
		isBanker = false,
		getSystemBetGroupName,
		setShowGroupingDialog,
	} = props;

	const isBankerDisabled = numOfItemsInBetslip <= 2 && !isBanker;

	const highlightCurrentGroup = (groupIndex: number) => {
		return getSystemBetGroupName(outcomeId) === systemBetGroupNameArray[groupIndex];
	};

	const handleChangeGroup = (groupIndex: number) => {
		changeGroup(outcomeId, groupIndex);
		setShowGroupingDialog();
	};

	const handleBankerSelection = () => {
		handleSelectedBet(!isBanker, outcomeId);
		setShowGroupingDialog();
	};

	const removeBetFromBetslip = () => {
		removeBet(outcomeId);
		setShowGroupingDialog();
	};

	return (
		<Dialog
			maxWidth="xs"
			className="custom-dialog bg--transparent custom--box-shadow text--center"
			aria-labelledby="customized-dialog"
			open={showGroupingDialog}
		>
			<div className="SystemBetGroupingPopup" ref={dialogRef}>
				<div className="SystemBetGroupingPopup__deleteBtn" onClick={() => removeBetFromBetslip()} data-cy="bs-system-delete">
					<span>{t('deleteSlip')}</span>
					<TrashIcon />
				</div>
				<hr className="SystemBetGroupingPopup__separator" />
				<div className="SystemBetGroupingPopup__groupSelection">
					<p className="SystemBetGroupingPopup__groupParagraph">{t('selectSystemSlipGroup')}</p>
					<Button
						btnType="transparent"
						className="SystemBetGroupingPopup__btn SystemBetGroupingPopup__sureBetBtn"
						onClick={() => handleBankerSelection()}
						disabled={isBankerDisabled}
						cyTestRef="surebet-button"
					>
						{t('sureBet')}
					</Button>
					<div className="SystemBetGroupingPopup__btnList">
						{groupArray.map((_, groupIndex) => (
							<div
								key={`number-${groupIndex}`}
								className={cn('SystemBetGroupingPopup__btn SystemBetGroupingPopup__selectGroupBtn', {
									'SystemBetGroupingPopup__selectGroupBtn--isSelected': highlightCurrentGroup(groupIndex),
								})}
								onClick={() => handleChangeGroup(groupIndex)}
								data-cy="bs-system-selectgroup"
							>
								{systemBetGroupNameArray[groupIndex]}
							</div>
						))}
					</div>
				</div>
			</div>
		</Dialog>
	);
};

export default SystemBetGroupingPopup;
